import React, { useState } from "react";
import { Button, Typography, useTheme } from "@material-ui/core";

const TruncateText = ({ text, maxLength = 30 }) => {
  const [showMore, setShowMore] = useState(false);
  const theme = useTheme();
  if (!text) return null;

  const isLong = text.length > maxLength;
  const displayText = !showMore && isLong ? text.substring(0, maxLength) + "..." : text;

  return (
    <div>
      <Typography variant="body2" component="span" style={{ color: theme.palette.listItem }}>
        {displayText}
      </Typography>
      {isLong && (
        <Button
          size="small"
          color="primary"
          style={{ textTransform: "none", marginLeft: 4 }}
          onClick={() => setShowMore(!showMore)}
        >
          {showMore ? "Show less" : "More"}
        </Button>
      )}
    </div>
  );
};

export default TruncateText;
